import React from "react";
import "./Card.css";

export type CardProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Card = ({
  className = "",
  children,
  ...props
}: CardProps & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div 
      className={`ds2-card ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export type CardHeaderProps = {
  className?: string;
  children?: React.ReactNode;
};

export const CardHeader = ({
  className = "",
  children,
  ...props
}: CardHeaderProps & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div 
      className={`ds2-card-header ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export type CardTitleProps = {
  className?: string;
  children?: React.ReactNode;
};

export const CardTitle = ({
  className = "",
  children,
  ...props
}: CardTitleProps & React.ComponentPropsWithoutRef<"h4">) => {
  return (
    <h4 
      className={`ds2-card-title ${className}`}
      {...props}
    >
      {children}
    </h4>
  );
};

export type CardDescriptionProps = {
  className?: string;
  children?: React.ReactNode;
};

export const CardDescription = ({
  className = "",
  children,
  ...props
}: CardDescriptionProps & React.ComponentPropsWithoutRef<"p">) => {
  return (
    <p 
      className={`ds2-card-description ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export type CardContentProps = {
  className?: string;
  children?: React.ReactNode;
};

export const CardContent = ({
  className = "",
  children,
  ...props
}: CardContentProps & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div 
      className={`ds2-card-content ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export type CardFooterProps = {
  className?: string;
  children?: React.ReactNode;
};

export const CardFooter = ({
  className = "",
  children,
  ...props
}: CardFooterProps & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div 
      className={`ds2-card-footer ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};